import axios from "axios";

import config from "../config/config";
import { getToken } from "../common";

export const deleteAPIKeyAPI = async ({ name }) => {
  return await axios({
    method: "delete",
    url: `${config.api.base_url}api-keys/${name}`,
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: getToken(),
    },
  });
};

export default deleteAPIKeyAPI;
